var winstatus = 'scrollbars=yes,menubar=no,height=800,width=1024,resizable=yes,toolbar=no,location=no,status=no';

var $trsMap = new Object();

var userLogged = false;
var isSearchFormCollapse = 0;

var totalAdult = 0;
var totalChild = 0;
var totalRoomCount = 0;
var totalPrice = 0.0;
var currency="";

var autoCompleteResult="";
var roomSelectedPreviously = false;

var  hotelSearch = {
	searchAutoCompleteId:null,
	searchUrl:null,
	fromDate:null,
	toDate:null
};

$.extend($.ui.menu.prototype.options, {
    items: "> :not(.ui-autocomplete-category)"
});

var selectedBoards = [];

//window.onbeforeunload = function (){
//	var isHotelDetail = $("[name='hotelDetail']").val();
//	if(!isHotelDetail){
//		putCookieSearchValues();
//	}
//};

$(document).ready(function() {
	checkAndSetTotalPrice();
    var isHotelDetail = $("[name='hotelDetail']").val();
    if(!isHotelDetail){
        parseCookieSearchValues();
    }

	if(Hotel.source){
		var date = new Date();
		date.setTime(date.getTime() + (30 * 60 * 1000)); //30 minutes
		$.cookie('source', Hotel.source, { expires : date,  path : '/' });
	}
	
	$( "#tabs" ).tabs();
	
	$( "#tabs" ).on( "tabsactivate", function(event, ui) {

		if (ui.newTab.attr("aria-controls") == "hotelMap") {
			map.option("zoom", 15);
			$('#map_canvas').gmap('refresh');
		}

	});
	
	$('.hotelAutoComplete').on('change', function() {
		$('html, body').animate({scrollTop: $("#hotelSearch").offset().top}, 500);
	});

	$("#large_images li").each(function(index, element) {
		$(element).attr("class", 'hide');
	});
	$("#large_images li").each(function(index, element) {
		$(element).attr("id", 'img' + index);
	});
	$("#thumb_holder li a").each(function(index, element) {
		$(element).attr("rel", 'img' + index);
	});

	var mainImg = 'img0';
	var current = 'img0';

	$('#img0').css('display', 'inline');
	$('#img0').addClass('current');

	$('#thumb_holder li a').click(function() {
		mainImg = $(this).attr('rel');
		if (mainImg != current) {
			$('.current').fadeOut('slow');
			$('#' + mainImg).fadeIn('slow', function() {
				$(this).addClass('current');
				current = mainImg;

			});
		}
	});
	
	$('#showThumbs').click(function() {
		$("#bx-pager").toggleClass('opened');
	});
	
	$('#makeSearch').click(function(event) {
		$("#sumButton").trigger('click');
	});
	$('.price-detail-icon').click(function() {
		$(".price-details").fadeToggle('fast');
	});
	
	$('[name="hotelSearchForm"]').validate();
	$('[name="searchFormHotelColapse"]').validate();
	
	$trsMap["hotel"] = $("table[hotels=all]>tbody>tr");
	var $trs = $trsMap["hotel"];
	$trs.find("a.show").hide();
	
	bindDatePicker();
	
	$( ".roomSelect" ).spinner({});
	$( ".adultCount" ).spinner({});
	$( ".childCount" ).spinner({});
	$( ".childAge" ).spinner({});
	
	$(document).on("spinstop",".roomSelect, .adultCount, .childCount, .childAge",function(){
		$(this).change();
	});
	
	$(document).on("click",".travelerSelect",function() {
		$(this).closest("form").find('.guestList').toggle("fade","fast");
		$('.mob-modal').show();
		
		$( ".roomSelect" ).spinner({});
		$( ".adultCount" ).spinner({});
		$( ".childCount" ).spinner({});
		$( ".childAge" ).spinner({});
		return false;
	});
	
	
	$('body').click(function(event) {
		if (!$(event.target).closest('.guestList').length) {
			$('.guestList,.mob-modal').hide();
		};
	});	

	$(".pop-close-btn,.pop-btn-ok").click(function() {
		$('.guestList,.mob-modal').hide();
		return false;
	});
	
	$("#showFilter").click(function() {
		$('.resultLeft').fadeToggle("fast");
		return false;
	});
	
	$(".btn-horizontal").click(function() {
		$(this).addClass("active");
		$(".btn-vertical").removeClass("active");
		$("#link-table").removeClass("vertical");
	});
	$(".btn-vertical").click(function() {
		$(this).addClass("active");
		$(".btn-horizontal").removeClass("active");
		$("#link-table").addClass("vertical");
	});

	$.widget("custom.catcomplete", $.ui.autocomplete, {
		_renderMenu : function(ul, items) {
			var that = this, currentCategory = "";
			$.each(items, function(index, item) {

				if (item.category != currentCategory) {

					if (item.category == "HOTEL") {
						ul.append("<li class='ui-autocomplete-category ui-state-disabled iconHotel' >" + FmtMessage.getMessage('js.result.hotel') + "</li>");
					} else if (item.category == "CITY") {
						ul.append("<li class='ui-autocomplete-category ui-state-disabled iconCity' >" + FmtMessage.getMessage('js.result.city') + "</li>");
					} else if (item.category == "DISTRICT") {
						ul.append("<li class='ui-autocomplete-category ui-state-disabled iconDistrict' >" + FmtMessage.getMessage('js.result.district') + "</li>");
					}

					currentCategory = item.category;
				}
				that._renderItemData(ul, item);
			});
		},
        _renderItem: function (ul, item) {
    		item.label = item.value.replace(re, "<span class='searchTerm'>$1</span>");
    		return $("<li class='ui-autocomplete-item'></li>")
    			.data("ui-autocomplete-item", item)
    			.append("<a>" + item.label + "</a>")
    			.appendTo(ul);
    		}
	});
	 
	
	var re = null;
	$(".hotelAutoComplete").catcomplete(
	{   delay: 500,
		source : function(request, response) {
			$.ajax({
				url : "/hotel/hotels",
				dataType : "json",
				data : {
					output : 'json',
					results : 100,
					query : request.term
				},
			

				success: function(data) {
					if(data == null){
						data = [];
					}
					
					var itemList = $.map(data, function(item) {
							return {
								value: item.name + " ( " + item.hotelCount + " "+ FmtMessage.getMessage('js.title.hotel.name') + " ) ",
								key: item.id,
								category : item.type,
								name : item.name,
								hotelId:item.hotelId
							};
					});
					re = new RegExp("(" + $.ui.autocomplete.escapeRegex(request.term) + ")", "gi");
					
					var itemListNew = getHotelItemLabels(itemList);
					response(itemListNew);
				}				
			});
		},
		minLength : 2,
		select: function (a, b) {
			document.activeElement.blur();
			if(b.item.hotelId){
				$('[name="id"]', this.form).val(b.item.hotelId);
			}
			$('[name="id"]', this.form).val(b.item.key);
			$(this).data("autoCompleteResult", b.item.value);
			
			if(!$('[name="urlHotelName"]').length ){
				$('<input>').attr({
				    type: 'hidden',
				    id: 'urlHotelName',
				    name: 'urlHotelName'
				}).appendTo(this.form);
			}
			$('[name="urlHotelName"]').val(b.item.name);
		},
		open: function(event, ui) {
	        $('.ui-autocomplete').off('menufocus hover mouseover mouseenter');
	    }
	}).change(function (event) {
		if ($(this).data("autoCompleteResult") != this.value)
			$('[name="id"]', this.form).val("");
	});

	$.ui.autocomplete.prototype._renderItem = function (ul, item) {
		item.label = item.value.replace(re, "<span class='searchTerm'>$1</span>");
		return $("<li></li>")
			.data("ui-autocomplete-item", item)
			.append("<a>" + item.label + "</a>")
			.appendTo(ul);
		};

	bindRoomSelector();

	$trsMap["board"] = $("[boards=all]>div>div");
	
	$(document).on("change",".roomPickSelect",function() {
		resetSelections();
		setSelectedRooms();
		
	}).change();
	
	$(".hotelAutoComplete").click(function() {
		$(this).select();
	});
		
	$('input[readonly]').focus(function(){
	    this.blur();
	});
	
	$(document).on("click", ".btn-book",function() {
		var index = $(this).attr("index");
		var boardIndex = $(this).attr("boardIndex");
		var roomKey = $(this).attr("roomKey");
		
		if(boardIndex && roomKey){
			resetSelections();
			changeOneRoomPick(boardIndex, roomKey, index, true);
		}
		
		return bookHotel();
	});
	
//	$(document).on("click", ".btn-book", function() {
//		return bookHotel();
//	});
	

});

function checkAndSetTotalPrice(){
	$.each( $(".roomPickSelect"), function() {
		//check room is selected previously
		if($(this).find(':selected').val() > 0){
			roomSelectedPreviously = true;
			return false;
		}
	});
	if($.cookie("selectedTotalPrice") && roomSelectedPreviously){
		  $(".totalPrice").html($.cookie("selectedTotalPrice"));
	}
}

function bindDatePicker(context) {
	
	if (context == undefined)
		context = document;
	
	var now = new Date();
	now.setDate(now.getDate() + 1);
	var aYearLater = new Date(now.getFullYear() + 1, now.getMonth(), now.getDate());

    datepickerGoToToday();

	$(".hasDatePickerCheckIn", context).datepicker({
		dateFormat : "dd.mm.yy",
		numberOfMonths : 1,
		showButtonPanel: true,
        closeText: "x",
		minDate : now,
		maxDate : aYearLater,
		onSelect : function(dateText, inst) {
			
			var selDate = $.datepicker.parseDate("dd.mm.yy", dateText);
			$(".hasDatePickerCheckIn", context).datepicker("setDate", selDate);
			var $checkOutDate = $('.hasDatePickerCheckOut', this.form);
			var endDateStr = $checkOutDate.val();
			var endDate = null;
			if (endDateStr != "")
				endDate = $.datepicker.parseDate("dd.mm.yy", endDateStr);
			$(".hasDatePickerCheckOut", context).datepicker("option", "minDate", selDate);
			if (endDate == null || selDate.getTime() >= endDate.getTime()) {
				var newEndDate = new Date(selDate);
				newEndDate.setDate(newEndDate.getDate() + 6);
				$(".hasDatePickerCheckOut", context).datepicker("setDate", newEndDate);
				var endDateStr = $checkOutDate.val();
			}
			$(this).blur();
		}
	});
	
	
	var minDate = null;
	var minDateStr = $(".hasDatePickerCheckIn:first", context).val();
	minDateStr == "" ? minDate = new Date():minDate = $.datepicker.parseDate("dd.mm.yy",minDateStr);
	minDate.setDate(minDate.getDate() + 1);
	var maxDate = new Date();
	maxDate.setFullYear(minDate.getFullYear() + 1);
	$(".hasDatePickerCheckOut", context).datepicker({
		dateFormat : "dd.mm.yy",
		numberOfMonths : 1,
		showButtonPanel: true,
        closeText: "x",
		minDate : minDate,
		maxDate : maxDate,
		onSelect : function (dateText, inst) {
			var selDate = $.datepicker.parseDate("dd.mm.yy", dateText);
			$(".hasDatePickerCheckOut", context).datepicker("setDate", selDate);
			$(this).blur();
		}
	});

}


function bindRoomSelector(context) {
	
	if (context == undefined)
		context = document;
	
	$(".roomSelect", context).on('change', function(event) {

		var roomCount = $(this).val();
		$(".roomSelect").val(roomCount);
		$(".travelerSelectRoom").html(roomCount);
		for ( var i = 1; i < 5; i++) {
			if (i <= roomCount) {
					$(".room" + i).show();
			} else {
					$(".room" + i).hide();
			}
		}
//		$(this).closest("form").find(".travelerSelectRoom").html(roomCount);
		setTotalGuest($(this).closest("form"));
		
		var locale = $.cookie('siteLocale');
		if(locale == "en" && roomCount > 1){
			$(".travelerRoomFmt").html(FmtMessage.getMessage('js.hotel.search.title.rooms'));
		}else{
			$(".travelerRoomFmt").html(FmtMessage.getMessage('js.hotel.search.title.room'));
		}
		
	}).change();

	$(".childCount", context).on('change', function (event) {

		var childCount =  parseInt(this.value);
		var index = this.name.split('_')[1];
		$("[name="+this.name+"]").val(childCount);

		for ( var i = 1; i < 4; i++) {
			if (i <= childCount) {
				$(".childAge" + index + i).show();
			} else {
				$(".childAge" + index + i).hide();
			}
		}
		
		setTotalGuest($(this).closest("form"));
        
	}).change();
	
	$(".adultCount", context).on('change', function (event) {
		$("[name="+this.name+"]").val(parseInt(this.value));
		setTotalGuest($(this).closest("form"));
	}).change();
	
	$(".childAge", context).on('change', function (event) {
		$("[name="+this.name+"]").val(parseInt(this.value));
	}).change();
	
}

function setTotalGuest(form) {
	var roomCount = parseInt(form.find("#glRoomCount").val());
	var totalAdultCount = 0;
	var totalChildCount = 0;
	for ( var i = 1; i <= roomCount; i++) {
		totalAdultCount = totalAdultCount + parseInt(form.find("[name=adultCount_" + i + "]").val());
		totalChildCount = totalChildCount + parseInt(form.find("[name=childCount_" + i + "]").val());
	}
	var totalGuest = totalAdultCount + totalChildCount;
	$(".travelerSelectGuest").html(totalGuest);
	var locale = $.cookie('siteLocale');
	if(locale == "en" && totalGuest > 1){
		$(".travelerGuestFmt").html(FmtMessage.getMessage('js.hotel.search.title.guests'));
	}else{
		$(".travelerGuestFmt").html(FmtMessage.getMessage('js.hotel.search.title.guest'));
	}
}

function setSelectedRooms() {
	//her secilen oda icin hesaplamaya git.
	$(document).find(".roomPickSelect").each(function(index, value){
		var boardIndex = $(this).attr("boardIndex");
		var roomKey = $(this).attr("roomKey");
		var pickRoomCount =$(this).val();
		var roomIndex = $(this).attr("index");

		if(!boardIndex || !roomKey || pickRoomCount==0) return;

		selectedBoards.push(boardIndex);
		$("[name=selectedBoardIndex]").val(selectedBoards.join());
		var price = parseFloat($(this).attr("price"));
		currency = $(this).attr("currency");
		var roomNum = parseInt($(this).val());
		var subTotal = parseFloat(price * pickRoomCount);
		totalPrice = totalPrice + subTotal;
		
		$("#roomNum_"+ boardIndex+ "_" + roomIndex).val(roomNum);
		
		var adult = parseInt($(this).attr("adultCount"));
		var child = parseInt($(this).attr("childCount"));
		
		totalAdult += adult * pickRoomCount;
		totalChild += child * pickRoomCount;
		totalRoomCount += parseInt(pickRoomCount);

		updatePriceView();
	});
}

function setSelectedRoomsOld(){
	
	var roomCount = $('[name="roomSelect"]').val();
	
	if(roomCount==1) return;
		
	for ( var i = 0; i < roomCount; i++) {
		
		// get ref index
		var refIndex = $("#refIndex_" + i).val();
		if (!refIndex) {
			return;
		}
		var boardIndex = $("#roomSelect_" + i + "_" + refIndex).attr("boardIndex");
		var roomKey = $("#roomSelect_" + i + "_" + refIndex).attr("roomKey");

		if(!boardIndex || !roomKey) return;
		
		changeRoomPick(boardIndex, roomKey, refIndex, true);
		
	}
}


function changeOneRoomPick(boardIndex, roomKey, refIndex, changeExplicit){
	$("#selectedBoardIndex").val(boardIndex);
	
	var self = $("#roomSelect_" + boardIndex + "_" + refIndex);
	var price = parseFloat(self.attr("price"));
	var currency = self.attr("currency");
	var roomNum = 0;
	var pickRoomCount = 0;
	
	if(changeExplicit){
		self.val(parseInt(self.val()) + 1);
	}
	
	pickRoomCount = parseInt(self.val());
	roomNum = parseInt(self.val());
	
	var subTotal = parseFloat(price * pickRoomCount);
	hotelSearch.totalPrice += subTotal;
	
	$("#roomNum_"+ boardIndex + "_" + parseInt(refIndex)).val(roomNum);
	
	var adult = parseInt(self.attr("adultCount"));
	var child = parseInt($(self).attr("childCount"));
	
	totalAdult += adult * pickRoomCount;
	totalChild += child * pickRoomCount;
	totalRoomCount += pickRoomCount;

	updatePriceView();
  
  var $trs = $trsMap["board"];
  $trs.show();
 
	  
//	  $trs.not("[boardIndex="+boardIndex+"]").find("select").val("0");  // attr('selected',true).change();
	
}

function updatePriceView(){
	if(totalPrice > 0){
		  var date = new Date();
		  date.setTime(date.getTime() + (15 * 60 * 1000)); //15 minutes
		  $.cookie('selectedTotalPrice',  totalPrice.toFixed(2) + " " + currency , { expires : date,  path : '/' });
		  $(".totalPrice").html(totalPrice.toFixed(2) + " " + currency);
		  $("#totalPriceInput").val(totalPrice.toFixed(2));
		  $(".btn-book").removeAttr("disabled");
	  }else{
		  
		  $(".totalPrice").html("");
		  $("#totalPriceInput").val(0);
		  $(".btn-book").attr("disabled", "disabled");
	  } 
}

function resetSelections(){
	
	$.cookie("selectedTotalPrice", null, { path: '/' });
	$("#selectedBoardIndex").val(0);
	$(".totalPrice").html("0" + currency);
	$(".roomNumValue").val(0);
	totalAdult=0;
	totalChild=0;
	totalRoomCount=0;
	totalPrice=0;
	selectedBoards = [];
}


function changeRoomPick(boardIndex, roomKey, refIndex, changeExplicit){
	 
	 // var boardIndex = $(this).attr("boardIndex");
	  $("#selectedBoardIndex").val(boardIndex);
	  var roomCount = $("#roomCount_"+ boardIndex).val();
	  if(roomCount > 0){
		  
//		var subTotal = 0;
		var roomNum = 0 , pickRoomCount = 0;
		
		for (var i = 0; i < roomCount; i++){
			
			var self = $("#roomSelect_" + boardIndex + "_" + i);
			var price = parseFloat(self.attr("price"));
			currency = self.attr("currency");
			
			if(changeExplicit && i == refIndex){
//				pickRoomCount = parseInt(self.val());
//				roomNum = parseInt(self.val());
//				roomNum = roomNum + 1;
//				pickRoomCount = pickRoomCount + 1;
				
				self.val(i + 1);
				
//			}else{
				
			}
			pickRoomCount = parseInt(self.val());
			roomNum = parseInt(self.val());
			
			
			var subTotal = parseFloat(price * pickRoomCount);
			totalPrice = totalPrice + subTotal;
			
			// var roomKey = $(this).attr("roomKey");
			// $("#roomKey_"+ boardIndex+ "_" + i).val(roomKey);
			$("#roomNum_"+ boardIndex+ "_" + i).val(roomNum);
			
			var adult = parseInt(self.attr("adultCount"));
			var child = parseInt($(self).attr("childCount"));
			
			totalAdult += adult * pickRoomCount;
			totalChild += child * pickRoomCount;
		}
		
	  }
	
	  if(totalPrice > 0){
		  
		  $(".totalPrice").html(totalPrice.toFixed(2) + " " + currency);
		  $("#totalPriceInput").val(totalPrice.toFixed(2));
		  $("#bookButton").removeAttr("disabled");
	  }else{
		  
		  $(".totalPrice").html("");
		  $("#totalPriceInput").val(0);
		  $("#bookButton").attr("disabled", "disabled");
	  } 
      
	  var $trs = $trsMap["board"];
	  $trs.show();
	  
	  if(!changeExplicit){
		  // $trs.not("[boardIndex="+boardIndex+"]").hide();
		  // $trs.find("a.show").show();
	  }
	  
	  $trs.not("[boardIndex="+boardIndex+"]").find("select").val("0");  // attr('selected',true).change();
	
}


function getHotelItemLabels(itemList){
	
	var itemListNew = $.map(itemList, function(item) {
		var category = item.category;
		if (category == "HOTEL"){
			item.value = item.name;
		}
		return item;
	});
	
	return itemListNew;
}

function checkForSearchHotel(form) {
	var formValid = $(form).valid();
	var id = $('[name="id"]', form).val();
	
	//in case autocomplete is not selected	
	var urlHotelName = $('[name="hotelName"]').val();
	if(!id){
		$('[name="urlHotelName"]').val(urlHotelName);
	}

	if(formValid) {
		
		var fromDate = $("[name=checkInDate]", form).val();
		var toDate = $("[name=checkOutDate]", form).val();
		
		fromDate = $.datepicker.parseDate("dd.mm.yy", fromDate);
		toDate = $.datepicker.parseDate("dd.mm.yy", toDate);

		var day = 24*60*60*1000;
		var duration = Math.round(Math.abs((fromDate - toDate)/(day)));
		
		if(duration > 30){
			$("#searchDialog").dialog({
				resizable : false,
				height : 240,
				width : 400,
				modal : true,
				buttons : [ {
					text : FmtMessage.getMessage('js.search.no.result'),
					click : function() {
						$(this).dialog("close");
					}
				} ]
			});

		}else{
			openLoaderBox("Hotel");
			putCookieSearchValues();
			form.submit();
		}
		
	}
	
}

function submitFormCollapse(form) {
	
	var formValid = $(form).valid();
	
	if(formValid) {
//		$('[name="urlHotelName"]').val($(form).attr("hotelName"));
		var mainForm = setMainFormVal(form);
		checkForSearchHotel(mainForm);
	}
	
}

function submitFormByLink(id, name) {

	var mainForm = $('form[name="hotelSearchForm"]')[0];
	$('[name="id"]', mainForm).val(id);
	$('[name="urlHotelName"]', mainForm).val(name);
	
	checkForSearchHotel(mainForm);
}

function submitFormAjax(form) {

	openLoaderBox("Hotel");
	setMainFormVal(form);
	var collapseForm = $('form[name="searchFormHotelColapse"]')[0];
	setAnyFormVal(form, collapseForm);
	var serialData = $(form).serialize();
	$.ajax({
		url : '/hotelResultAjax',
		type : 'post',
		data : serialData
	}).done(function (html) {
		$('#priceSearchLoader').html(html);
		var searchForm = $('#priceSearchLoader form[name="hotelSearchForm"]');
		if (searchForm.length == 1) {
			bindDatePicker(searchForm);
			bindRoomSelector(searchForm);
		} 
		if ($('#priceDetailHotelForm').length == 1) {
			setSelectedRooms();
		}
	}).always(function () {
		closeLoaderBox();
	});
}

function setMainFormVal(form) {
	
	var mainForm = $('form[name="hotelSearchForm"]')[0];
	setAnyFormVal(form, mainForm);
	return mainForm;
}

function setAnyFormVal(form, anyForm) {
	
	$('[name]', form).each(function (index, item) {
		$('[name="' + item.name + '"]', anyForm).val(item.value);
		
	});
}

function bookHotel() {
	
	  var formValid = true;
	  var numAdult = parseInt($("#numAdult").val());
	  var numChild = parseInt($("#numChild").val());
	  var numRoom = parseInt($("#numRoom").val());
	  
	  if(roomSelectedPreviously){
		  resetSelections();
		  setSelectedRooms();
	  }
	  if (totalAdult < numAdult){
		  	formValid = false;
			alert(FmtMessage.getMessage('js.adult.count.less'));
			return false;
	  } 
	  
	  if (totalChild < numChild){
		  formValid = false;
		  alert(FmtMessage.getMessage('js.child.count.less'));
		  return false;
	  }

	  if(totalRoomCount > numRoom){
          formValid = false;
          alert(FmtMessage.getMessage('js.room.count.invalid'));
          return false;
	  }
	  
	  if(formValid){
		  openLoaderBox("Hotel");
		  return checkRoomAndPaxCount();
	  }
	  
	
			
}

function checkRoomAndPaxCount(){
		var adultCount = 0, childCount = 0;
		var adultMaxTotal = 0, childMaxTotal = 0;
		$(document).find(".roomPickSelect").each(function(){
			var roomCount = $(this).val();
			if(roomCount > 0){
				adultMaxTotal += $(this).attr("adultCount") * roomCount;
				childMaxTotal += $(this).attr("childCount") * roomCount;
			}
		});
		var $form = $('[name="hotelSearchForm"]');
		var roomC = $form.find('[name="roomSelect"]').val();
		for (var i = 1; i <= roomC; i++) {
			adultCount += parseInt($form.find('[name="adultCount_' + i + '"]').val(), 10);
			childCount += parseInt($form.find('[name="childCount_' + i + '"]').val(), 10);
		}
		if(adultMaxTotal < adultCount || childMaxTotal < childCount){
			closeLoaderBox();
			alert(Hotel.roomCapacity);
		    $(".btn-book").removeAttr("disabled");

			return false;
		}
		$("#priceDetailHotelForm").submit();
		return true;
//				else if(adultMaxTotal > adultCount || childMaxTotal > childCount){
//					closeLoaderBox();
//					alert(Hotel.capacityGreater);
//					return false;
//				}
		
//	});
	
}

function showList(index){
	
	var $trs = $trsMap["hotel"];
	$trs.not("[index="+index+"]").show();	
	$trs.find("a.show").hide();
}

function showList2(index){
	
	var $trs = $trsMap["hotel2"];
	$trs.not("[index="+index+"]").show();	
	$trs.find("a.show").hide();
}

function showList3(index){
	
	var $trs = $trsMap["board"];
	$trs.not("[boardIndex="+index+"]").show();	
	$trs.find("a.show").hide();
}

function showHotelDetail(index){
	var item = $("#hotelRowId_"+index);
	var _channelid = $("#priceDetailHotelForm input[name=channelId]").val();
	var _providerCode = $("#priceDetailHotelForm input[name=providerCode]").val()
	var _hotelName= $("#priceDetailHotelForm input[name=hotelName]").val()
	var _id = $("#priceDetailHotelForm input[name=id]").val()
	
	$("#priceDetailHotelForm input[name=channelId]").val($(item).attr("channelId"));
	$("#priceDetailHotelForm input[name=providerCode]").val($(item).attr("providerCode"));
	$("#priceDetailHotelForm input[name=urlHotelName]").val($(item).attr("hotelName"));
	$("#priceDetailHotelForm input[name=id]").val($(item).attr("autocompleteId"));
	$("#priceDetailHotelForm").submit();
	
	$("#priceDetailHotelForm input[name=channelId]").val(_channelid);
	$("#priceDetailHotelForm input[name=providerCode]").val(_providerCode);
	$("#priceDetailHotelForm input[name=urlHotelName]").val(_hotelName);
	$("#priceDetailHotelForm input[name=id]").val(_id);
}

function parseCookieSearchValues() {
    if(($('input[type=hidden][name="overrideSearchForm"]')&&$('input[type=hidden][name="overrideSearchForm"]').val()))
        putCookieSearchValues();
	if($.cookie('hotelSearchValues') ){
		var now = new Date();
		var searchData = JSON.parse($.cookie("hotelSearchValues"));
		$('.hotelAutoComplete').data("autoCompleteResult", searchData.searchAutoCompleteId);
		
		if(!$('[name="urlHotelName"]').length ){
			$('<input>').attr({
			    type: 'hidden',
			    id: 'urlHotelName',
			    name: 'urlHotelName'
			}).appendTo(this.form);
		}
		$('[name="urlHotelName"]').val(searchData.searchUrl);
		$('[name="hotelName"]').val(searchData.searchUrl);
		$('[name="id"]').val(searchData.searchAutoCompleteId);
		if(searchData.fromDate !=null && searchData.fromDate.length > 0){
			var from = $.datepicker.parseDate("dd.mm.yy", searchData.fromDate);
			var formattedFromDate = searchData.fromDate;
			if(now.getTime() > from.getTime()){
				from = new Date();
				from.setDate(from.getDate() + 1);
				formattedFromDate = $.datepicker.formatDate("dd.mm.yy", from);
			}
			
			$(".hasDatePickerCheckIn", document).datepicker("setDate", from);
			$(".hasDatePickerCheckIn").val(formattedFromDate);

		}
		if(searchData.toDate != null && searchData.toDate.length > 0){
			var to = $.datepicker.parseDate("dd.mm.yy", searchData.toDate);
			var formattedToDate = searchData.toDate;
			if(now.getTime() > to.getTime()){
				to = new Date();
				to.setMonth(now.getMonth(), now.getDate() + 7)
				formattedToDate = $.datepicker.formatDate("dd.mm.yy", to);

			}
			$(".hasDatePickerCheckOut", document).datepicker("setDate", to);
			$(".hasDatePickerCheckOut").val(formattedToDate);
		}
	}
}

function putCookieSearchValues(){
	var date = new Date();
	date.setTime(date.getTime() + (24 * 60 * 60 * 1000)); //24 hour
	hotelSearch.searchAutoCompleteId = $('[name="id"]').val();
	hotelSearch.fromDate = $('[name="checkInDate"]').val();
	hotelSearch.toDate = $('[name="checkOutDate"]').val();
	hotelSearch.searchUrl = $('[name="urlHotelName"]').val();
	$.cookie('hotelSearchValues',  JSON.stringify(hotelSearch), { expires : date,  path : '/' });
}

function datepickerGoToToday(){

    var o_gotoToday = $.datepicker._gotoToday;

    $.datepicker._gotoToday = function(id) {

        o_gotoToday.call(this, id);
        var date = new Date();
        var selDate  = this.formatDate("dd.mm.yy", date);
        this._selectDate(id, selDate);

        var minDate = new Date();
        minDate.setDate(date.getDate() + 1)

        var newEndDate = new Date();
        newEndDate.setDate(date.getDate() + 7);

        $(".hasDatePickerCheckOut").datepicker('option', "minDate", minDate);
        $(".hasDatePickerCheckOut").datepicker("setDate", newEndDate);
    }
}
